export default {
    inputOwnAnswer: "Eigene Antwort eingeben",
    ownAnswer: "Eigene Antwort",
    addOwnAnswer: "Eigene Antwort hinzufügen",
    removeOptions: "Auswahl entfernen",
    new: "Neu"
}
